import { render, staticRenderFns } from "./LoadingArrow.vue?vue&type=template&id=74bf8f42&scoped=true"
import script from "./LoadingArrow.vue?vue&type=script&lang=js"
export * from "./LoadingArrow.vue?vue&type=script&lang=js"
import style0 from "./LoadingArrow.vue?vue&type=style&index=0&id=74bf8f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf8f42",
  null
  
)

export default component.exports